// src/theme.js
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#0055A6",        // Azul corporativo
    },
    secondary: {
      main: "#00A6A6",        // Azul petróleo / profissional
    },
    background: {
      default: "#f7f9fc",     // Cinza muito claro
      paper: "#ffffff",
    },
    text: {
      primary: "#1b2635",
      secondary: "#5c6b80",
    },
  },

  typography: {
    fontFamily: "'Inter', 'Roboto', sans-serif",
    h4: {
      fontWeight: 700,
      letterSpacing: "-0.5px",
    },
    h5: {
      fontWeight: 600,
    },
    body1: {
      fontSize: "0.95rem",
    },
  },

  shape: {
    borderRadius: 10, // deixa o layout mais premium
  },

  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        },
      },
    },

    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
          borderRadius: 8,
        },
      },
    },

    MuiTextField: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },

    MuiAccordion: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          marginBottom: 8,
          "&::before": { display: "none" },
        },
      },
    },
  },
});

export default theme;
